import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/Home';
import Download from './pages/Download';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import DieVilla from './pages/DieVilla';
import DieUmgebung from './pages/DieUmgebung';
import DeineAnreise from './pages/DeineAnreise';
import Bedingungen from './pages/Bedingungen';
import Kontakt from './pages/Kontakt';
import BookingRequest from './pages/BookingRequest';

// Wrapper component for language provider
const AppRoutes = () => {
  return (
    <LanguageProvider>
      <Routes>
        {/* German routes (default) */}
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<Download />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/die-villa" element={<DieVilla />} />
        <Route path="/die-umgebung" element={<DieUmgebung />} />
        <Route path="/deine-anreise" element={<DeineAnreise />} />
        <Route path="/bedingungen" element={<Bedingungen />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/buchung" element={<BookingRequest />} />
        
        {/* English routes */}
        <Route path="/en" element={<Home />} />
        <Route path="/en/download" element={<Download />} />
        <Route path="/en/privacy" element={<Datenschutz />} />
        <Route path="/en/imprint" element={<Impressum />} />
        <Route path="/en/the-villa" element={<DieVilla />} />
        <Route path="/en/the-area" element={<DieUmgebung />} />
        <Route path="/en/getting-here" element={<DeineAnreise />} />
        <Route path="/en/terms" element={<Bedingungen />} />
        <Route path="/en/contact" element={<Kontakt />} />
        <Route path="/en/booking" element={<BookingRequest />} />
        
        {/* Thai routes */}
        <Route path="/th" element={<Home />} />
        <Route path="/th/download" element={<Download />} />
        <Route path="/th/privacy" element={<Datenschutz />} />
        <Route path="/th/imprint" element={<Impressum />} />
        <Route path="/th/the-villa" element={<DieVilla />} />
        <Route path="/th/the-area" element={<DieUmgebung />} />
        <Route path="/th/getting-here" element={<DeineAnreise />} />
        <Route path="/th/terms" element={<Bedingungen />} />
        <Route path="/th/contact" element={<Kontakt />} />
        <Route path="/th/booking" element={<BookingRequest />} />
      </Routes>
    </LanguageProvider>
  );
};

function App() {
  return (
    <div className="App">
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    </div>
  );
}

export default App;
